module.exports = __webpack_public_path__ + "static/media/domain_names_amber.855a723c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Illustration/img/domain_names_amber.svg
// module id = 1105
// module chunks = 2